import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";

export const FAQS = [
  {
    q: "Are these authentic Ilkal sarees from Karnataka?",
    a: "Yes. Every saree at R V Ilkal Sarees comes from Ilkal, Bagalkot district, Karnataka — the home of the famous Ilkal weave with its signature temple border and contrast pallu. We bring original Ilkal sarees directly from the weavers' town to you.",
  },
  {
    q: "Do you deliver Ilkal sarees across India?",
    a: "Yes, we ship pan-India from Ilkal city via Delhivery, Bluedart, India Post and FedEx. Shipping is free on orders above ₹1,999; a flat ₹150 applies below that, and tracking is emailed once your saree ships.",
  },
  {
    q: "Is Cash on Delivery available when I buy Ilkal sarees online?",
    a: "Yes. You can pay online securely via UPI, cards or netbanking through Razorpay, or choose Cash on Delivery with a ₹150 handling fee.",
  },
  {
    q: "What fabrics do your handloom Ilkal sarees come in?",
    a: "Our collection includes pure cotton, viscose cotton, cotton-silk and pure silk Ilkal sarees — from light daily-wear drapes to bridal and premium handloom pieces.",
  },
];

export const Faq = () => (
  <section className="py-12 sm:py-16 bg-surface/60 border-y border-gold/20" data-testid="faq-section">
    <div className="max-w-3xl mx-auto px-4 sm:px-6">
      <p className="uppercase tracking-[0.25em] text-xs font-semibold text-gold text-center">Good to know</p>
      <h2 className="font-heading text-2xl sm:text-3xl lg:text-4xl tracking-tight font-medium text-charcoal mt-3 text-center">
        Ilkal Sarees — Questions, Answered
      </h2>
      <Accordion type="single" collapsible className="mt-7">
        {FAQS.map((f, i) => (
          <AccordionItem key={i} value={`faq-${i}`} className="border-gold/20">
            <AccordionTrigger className="text-left font-heading text-lg text-charcoal hover:no-underline hover:text-maroon" data-testid={`faq-q-${i}`}>
              {f.q}
            </AccordionTrigger>
            <AccordionContent>
              <p className="text-sm text-charcoal/70 leading-relaxed">{f.a}</p>
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  </section>
);
